<template>
  <div class="foclarity-chatbot">
    <div v-if="chat_messages.length == 0">
      <div style="text-align: center;margin:18px 0;">
        <img :src="require('@/assets/ic_sparkle.png')" width="20" height="20" alt="AI Chat" title="AI Chat" style="margin:8px;" />
      </div>
      <div class="greeting" style="text-align: center;">
        <strong>{{ greeting_message }}, {{ user.first_name }}! </strong>
      </div>
      <div style="text-align: center;">
        <p>How can I help you today?</p>
      </div>
    </div>
    <div class="row" v-if="chat_messages.length > 0" style="max-width: 800px;margin:auto;">
      <div class="column">
        <div class="chatbox" ref="chatbox">
          <div v-for="(msg, index) in chat_messages" :key="index" :class="msg.sender ? 'chatmsg user' : 'chatmsg bot'">
            <div v-if="msg.sender === 'user'" style="text-align:left;margin-bottom:40px;">
              <div style="font-weight: bold;">
                <div v-if="user.profile_image" :style="'border-radius:50%;width:30px;height:30px;background:url(https://corl8-files.s3.amazonaws.com/' + user.profile_image +') no-repeat;background-size:cover;display:inline-block;vertical-align:middle;margin-right:8px;'"></div>
                <div v-else style="border-radius:50%;width:30px;height:30px;display:inline-block;vertical-align:middle;margin-right:10px;" >
                  <img style="width:30px;height:30px;" :src="require('@/assets/ic_person.png')" alt="profile icon" />
                </div>
                <div style="display:inline-block;vertical-align:middle;">
                  {{ user.first_name }}
                </div>
              </div>
              <div style="padding:10px 0 0 40px;font-size:smaller;" class="scaps">
                {{ msg.text }}
              </div>
            </div>
            <div v-else style="text-align:left;margin-bottom:40px;">
              <div style="font-weight: bold;">
                <div style="width:30px;height:30px;display:inline-block;vertical-align:middle;text-align:center;padding:2px;margin-right:10px;" >
                  <img style="transform: rotateY(0deg) rotate(135deg);border-radius:50%;width:26px;height:26px;" :src="require('@/assets/foclarity-icon.png')" alt="Foclarity AI" />
                </div>
                <div style="display:inline-block;vertical-align:middle;" >
                  Foclarity.AI
                </div>
              </div>
              <div style="padding:10px 0 0 40px;font-size:smaller;">
                <div v-html="markedup(msg.text)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row" style="max-width: 800px;margin:auto;">
        <div class="column" >
          <div class="chatinput">
            <div style="float:right;height: 0;top:8px;">
              <img :src="require('@/assets/foclarity-icon.png')" @click="clickChat(chatmsg)" style="width:28px;height:28px;text-align:left;border-radius: 50%;margin-right:8px;cursor:pointer;transform: rotateY(0deg) rotate(135deg);" />
            </div>
            <textarea ref="chatBox" type="text" @disabled="chatmsg.length > 0" placeholder="Message Foclarity AI..." v-model="chatmsg" @keyup.enter="clickChat(chatmsg)" enterkeyhint="send" style="padding-right:40px;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chatService } from '../../_services';
import marked from 'marked';

export default {
  name: 'FoclarityChatbot',
  props: {
    user: { type: Object, required: true },
    greeting_message: { type: String, default: 'Hello' }
  },
  data() {
    return {
      chatID: 0,
      chatmsg: '',
      chat_messages: []
    };
  },
  methods: {
    clickChat(msg) {
      if (!msg || msg.trim() === '') return;
      this.chatmsg = 'Analyzing...';
      this.chat_messages.push({ text: msg, sender: 'user' });
      if (this.chatID === 0) {
        chatService.chat(msg, 0).then(
          data => {
            this.chat_messages.push({ text: data.chat_message.bot_message, sender: 'bot' });
            this.chatID = data.chat_message.chat_id;
            this.chatmsg = '';
          },
          error => {
            this.chat_messages.push({ text: "I'm sorry, there was an error: " + error, sender: 'bot' });
            this.chatmsg = '';
          }
        );
      } else {
        chatService.chat(msg, this.chatID).then(
          data => {
            this.chat_messages.push({ text: data.chat_message.bot_message, sender: 'bot' });
            this.chatID = data.chat_message.chat_id;
            this.chatmsg = '';
          },
          error => {
            this.chat_messages.push({ text: "I'm sorry, there was an error: " + error, sender: 'bot' });
            this.chatmsg = '';
          }
        );
      }
    },
    markedup(text) {
      return marked(text);
    }
  },
  watch: {
    chat_messages(newVal) {
      this.$nextTick(() => {
        if (newVal.length > 0 && newVal[newVal.length - 1].sender === 'user') {
          const chatbox = this.$refs.chatbox;
          if (chatbox) {
            chatbox.scrollTop = chatbox.scrollHeight;
          }
        } else {
          const chatbox = this.$refs.chatbox;
          if (chatbox) {
            // Scroll down by 60px, but not past the end
            const maxScroll = chatbox.scrollHeight - chatbox.clientHeight;
            chatbox.scrollTop = Math.min(chatbox.scrollTop + 120, maxScroll);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.foclarity-chatbot {
  width: 100%;
  max-width: 800px;
  margin: auto;
  /* background: #fff; */
}
.foclarity-chatbot .chatbox {
  min-height: 120px;
  max-height: 260px;
  overflow-y: auto;
  /* background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px #e9d6fa; */
  padding: 12px 8px;
}
.foclarity-chatbot .chatinput {
  margin-top: 0px;
  border-radius: 8px;
  padding: 8px;
}
</style>
